/* eslint-disable class-methods-use-this, default-case */
/**
 * Luma Group
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Form controller.
 */
export default class extends Controller {
  static targets = ['form', 'checkbox', 'label', 'success', 'linkedin', 'cv', 'description', 'other'];

  /**
   * Submit the form
   *
   * @param {Event} e
   */
  async submit(e) {
    e.preventDefault();
    e.submitter?.setAttribute('disabled', true);

    const body = new FormData(e.target);
    const response = await fetch(window.location.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
      body,
    });
    const result = await response.json();

    if ('success' in result) {
      if (window.dataLayer && body.has('application[email]')) {
        window.dataLayer.push({
          event: 'sollicitatie_verstuurd',
          applicant: {
            first_name: body.get('application[firstName]') || '',
            prefix: body.get('application[middleName]') || '',
            last_name: body.get('application[lastName]') || '',
            email: body.get('application[email]') || '',
          },
        });
      }

      this.formTarget.classList.add('hidden');
      this.successTarget.classList.remove('hidden');
    }

    e.submitter?.removeAttribute('disabled');
  }

  /**
   * Only require one checked checkbox per checkbox group.
   *
   * @param {Event} e
   */
  checkboxInput(e) {
    const checkboxes = this.checkboxTargets.filter((checkbox) => checkbox.name === e.target.name);
    const checkedBox = checkboxes.find((checkbox) => checkbox.checked);

    checkboxes.forEach((checkbox) => {
      if (checkedBox) {
        checkbox.removeAttribute('required');
      } else {
        checkbox.setAttribute('required', true);
      }
    });

    checkedBox?.setAttribute('required', true);
  }

  /**
   * Change label of the file input with the filename.
   *
   * @param {Event} e
   */
  fileInput(e) {
    const files = Array.from(e.target.files) ?? [];
    this.labelTarget.textContent = files.length ? files.map((f) => f.name).join(', ') : e.params.label;
  }

  /**
   * Toggle type of application.
   *
   * @param {Event} e
   */
  toggleType(e) {
    switch (e.target.value) {
      case 'linkedin':
        this.linkedinTarget.classList.replace('hidden', 'grid');
        this.linkedinTarget.querySelector('input').setAttribute('required', true);
        this.cvTarget.classList.replace('grid', 'hidden');
        this.descriptionTarget.classList.replace('flex', 'hidden');
        break;
      case 'motivation':
        this.linkedinTarget.classList.replace('grid', 'hidden');
        this.linkedinTarget.querySelector('input').removeAttribute('required');
        this.cvTarget.classList.replace('hidden', 'grid');
        this.descriptionTarget.classList.replace('hidden', 'flex');
        break;
    }
  }

  /**
   * Toggle custom other field.
   *
   * @param {Event} e
   */
  toggleOther(e) {
    const input = this.otherTarget.querySelector('input');

    if (e.target.checked) {
      this.otherTarget.classList.remove('hidden');
      input.setAttribute('required', true);
    } else {
      this.otherTarget.classList.add('hidden');
      input.removeAttribute('required');
      input.value = '';
    }
  }
}
